import { render, staticRenderFns } from "./TypeCardMessage.vue?vue&type=template&id=29a2b06d&scoped=true"
import script from "./TypeCardMessage.vue?vue&type=script&lang=js"
export * from "./TypeCardMessage.vue?vue&type=script&lang=js"
import style0 from "./TypeCardMessage.vue?vue&type=style&index=0&id=29a2b06d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a2b06d",
  null
  
)

export default component.exports